import { useState } from 'react'
import React from 'react'
import { AccountButton } from './components/AccountButton'
import { EntityAccountTab } from './components/EntityAccountTab'
import { IndividualAccountTab } from './components/IndividualAccountTab'

const PricingLawyers = () => {
  const [buttons, _] = useState<Array<string>>([
    'Entity Account',
    'Individual Account',
  ])
  const [selectedIndex, setSelectedIndex] = useState<number>(0)

  const switchTab = (index: number) => {
    setSelectedIndex(index)
  }

  return (
    <div className='flex flex-col justify-center items-center text-center mx-[20px] sm:mx-[40px] md:mx-[60px] lg:mx-[80px] my-8 sm:my-15'>
      <h1 className='font-bold text-lg sm:text-xl md:text-2xl lg:text-[40px] pb-3 md:pb-4'>
        Manage Your Professional Profile and Engage with Clients
      </h1>

      <p className='text-xs sm:text-base text-[#6E7785]'>
        Whether you're an individual lawyer or representing a law firm or
        barristers' chambers, Legal Utopia's Lawyer Portal provides tools and
        features that you can use to support your practice and enhance your
        visibility. The Lawyer Portal is a dedicated business development
        service where solicitors, barristers, law firms, and chambers can manage
        their profiles, handle bookings, and publish content, all in one place.
      </p>

      <div className='flex justify-between gap-2 p-[3px] rounded-lg shadow-inner-md my-10 sm:my-20'>
        {buttons.map((label, index) => (
          <AccountButton
            key={label + index}
            selected={index == selectedIndex}
            label={label}
            onClick={() => switchTab(index)}
          />
        ))}
      </div>

      <div
        className={`flex flex-col w-full px-[24px] sm:px-[70px] py-[20px] sm:py-[60px] 
                    rounded-3xl shadow-equal-all-sides border border-[#9C9CDF]`}
      >
        {buttons[selectedIndex] === 'Entity Account' && <EntityAccountTab />}

        {buttons[selectedIndex] === 'Individual Account' && (
          <IndividualAccountTab />
        )}
      </div>
    </div>
  )
}

export default PricingLawyers
